export default __webpack_public_path__ + "static/media/Belt of the Outer Dark.7af527d9.jpg";